// Removes leading slash and adds trailing slash
export const getSlugFromPathname = (pathname: string): string =>
  (pathname.startsWith('/') ? pathname.slice(1) : pathname) + (pathname.endsWith('/') ? '' : '/');
